import React from 'react';
import styled, { css } from 'styled-components';

import { BankIcon } from 'src/assets/bank-icon';
import { BankLogo } from 'src/account/bank-account/components/existing-user/existing-user.styles';

type CircleBankLogoProps = {
  altText?: string | null;
  logo?: string | null;
  circleDiameter?: number;
  iconHeight?: number;
  iconWidth?: number;
};

export const CircleBankLogo = ({
  altText = 'Bank logo',
  logo,
  circleDiameter = 20,
  iconHeight = 14,
  iconWidth = 14,
}: CircleBankLogoProps): JSX.Element => (
  <LogoWrapper diameter={circleDiameter}>
    {logo ? (
      <BankLogo
        alt={altText}
        width={`${iconWidth}px`}
        height={`${iconHeight}px`}
        src={`data:image/png;base64, ${logo}`}
      />
    ) : (
      <BankIcon height={iconHeight} width={iconWidth} />
    )}
  </LogoWrapper>
);

export const LogoWrapper = styled.figure<{ diameter: number; margin?: string; zIndex?: number }>`
  ${({ theme: { colors }, diameter, margin, zIndex }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${diameter}px;
    margin: ${margin || '0px'};
    height: ${diameter}px;
    padding: 3px;
    gap: 10px;
    border-radius: 800px;
    border: 1px solid ${colors.grey[90]};
    background: ${colors.white};
    z-index: ${zIndex || 0};
  `}
`;
